import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const TitleMdText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        testID="title-md"
        style={[styles.titleMdText, style]}
        {...props}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  titleMdText: {
    ...theme.typography.title.md,
    color: theme.color.text.primary,
  },
});

export default TitleMdText;
